import { getPhysicsWorker } from "../../physics/workerHandle";
import { logger } from "../../utils/logger";

type XmlDumpPayload = {
  xml?: string;
  filename?: string;
  error?: string;
};

const downloadXmlFromWorker = ({
  requestType,
  fallbackFilename,
  exportLabel,
}: {
  requestType: "exportXml" | "exportMainXml";
  fallbackFilename: string;
  exportLabel: string;
}) => {
  const worker = getPhysicsWorker();
  if (!worker) {
    logger.error("[physics] No worker available for XML export");
    return;
  }

  const handler = (ev: MessageEvent) => {
    const msg = ev.data;
    if (!msg || msg.type !== "xmlDump") return;

    worker.removeEventListener("message", handler);

    const { xml, filename, error } = (msg.payload || {}) as XmlDumpPayload;
    if (error || !xml) {
      logger.error(`[physics] ${exportLabel} XML export error:`, error || "no xml received");
      return;
    }

    try {
      const blob = new Blob([xml], { type: "application/xml" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename || fallbackFilename;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      logger.error(`[physics] Failed to download ${exportLabel} XML:`, error);
    }
  };

  worker.addEventListener("message", handler);
  worker.postMessage({ type: requestType });

  setTimeout(() => {
    worker.removeEventListener("message", handler);
  }, 5000);
};

export const exportWorkerXml = () => {
  downloadXmlFromWorker({
    requestType: "exportXml",
    fallbackFilename: "physics_worker.xml",
    exportLabel: "worker",
  });
};

export const exportMainXml = () => {
  downloadXmlFromWorker({
    requestType: "exportMainXml",
    fallbackFilename: "physics_main_attempt.xml",
    exportLabel: "main",
  });
};
